import { axiosClient } from "./axiosClient";

export interface TransactionFilters {
  status?: 'pending' | 'completed' | 'cancelled';
  transactionType?: 'sale' | 'exchange';
  cursor?: string;
  limit?: number;
}

// Fetch all transactions (admin only)
export const fetchTransactions = async (filters: TransactionFilters) => {
  const { data } = await axiosClient.get('/marketplace/transactions/admin/all', { params: filters });
  return data;
};

// Delete/cancel transaction (admin only)
export const deleteTransaction = async (transactionId: string, reason: string) => {
  const { data } = await axiosClient.delete(`/marketplace/transactions/admin/${transactionId}`, {
    data: { reason },
  });
  return data;
};
